import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FormBuilder } from '@kevlarcon/formkit';
import '../../styles/formkitTheme.css';
import { useQuery } from '@tanstack/react-query';
import AdminLayout from '../../components/AdminLayout';
import { formKitClient } from '../../api/formkitClient';
import { partnersApi } from '../../api/partners';

/**
 * Thin host page around `@kevlarcon/formkit`'s `FormBuilder` — the package
 * owns the whole palette · canvas · settings-rail authoring UI, including its
 * own header band (recolored to sgokit's navy/gold in sgokit.css, so no
 * `title` is passed to AdminLayout here — that would double up the header).
 * `fullBleed` skips AdminLayout's narrow centered column (built for the other
 * settings pages' simple forms) so the three-column builder gets the whole
 * width next to the sidebar, unlike GrantCentral's own form-builder page,
 * which renders standalone with no host chrome at all — sgokit's org admins
 * still need the sidebar nav to get here and back. `fullBleed` also pins the
 * layout to the viewport, so the palette, canvas and settings rail each scroll
 * on their own instead of the whole page.
 */
const PartnerFormBuilder: React.FC = () => {
  const navigate = useNavigate();
  const { data: form, isLoading } = useQuery({
    queryKey: ['partner-form'],
    queryFn: partnersApi.getForm,
  });

  if (isLoading || !form) {
    return (
      <AdminLayout>
        <p className="sgk-admin__sub" data-testid="partner-form-builder-loading">Loading…</p>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout fullBleed>
      <FormBuilder
        client={formKitClient}
        formId={form.id}
        onBack={() => navigate('/settings/partners')}
        backLabel="Partners"
        // The real page, as a visitor sees it — not the builder's in-canvas preview.
        previewHref="/partners/join"
      />
    </AdminLayout>
  );
};

export default PartnerFormBuilder;
